import { Form, FormItemProps, Select, SelectProps } from "antd";
import { twMerge } from "tailwind-merge";

interface IFormItemInputJobTitle extends FormItemProps {
  select?: SelectProps;
}

const FormItemInputJobTitle = ({
  select,
  label,
  className,
  ...props
}: IFormItemInputJobTitle) => {
  return (
    <>
      <Form.Item label={label} name="jobTitle" {...props} className={className}>
        <Select
          placeholder="직무를 선택해 주세요."
          options={[
            { value: "대표", label: "대표" },
            { value: "마케터", label: "마케터" },
            { value: "기획자", label: "기획자" },
            { value: "MD", label: "MD" },
            { value: "개발자", label: "개발자" },
            { value: "디자이너", label: "디자이너" },
            { value: "기타", label: "기타" },
          ]}
          {...select}
          className={twMerge("text-base text-black", select?.className)}
        />
      </Form.Item>
    </>
  );
};

export default FormItemInputJobTitle;
